module.exports = __webpack_public_path__ + "static/img/video_cover.8db3c22a.png";